import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import accountBg from 'assets/images/bg/account.jpg';
const lotteryPageStyles = {
    wrapPage: css`
        background: url(${accountBg}) no-repeat;
        background-size: cover;
        height: 100%;
        padding: 24px 0;
    `,
    wrapInner: css`
        display: flex;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        background: #f5f6fb;
    `,
    sidebar: css`
        flex: 0 0 240px;
        max-width: 240px;
        /* border-right: 1px solid #dfeeff; */
        padding: 24px 5px;
        background: linear-gradient(to bottom, #1b53f0, #011e98);
        border-radius: 10px;
    `,
    betContainer: css`
        padding: 10px;
        flex: 1;
        width: 64%;
    `,
    resultSection: css`
        display: flex;
        gap: 8px;
        border-radius: 8px 8px 0 0;
        color: ${colors.white};
        padding: 8px;
        width: 20%;
    `,

    issueWrap: css`
        flex: 1;
        max-width: 400px;
        margin-left: auto;
        background: #2d276d;
        border-radius: 6px;
        padding: 10px 8px;
        border: 1px solid ${colors.borderPrimary};
        display: flex;
        flex-direction: column;
    `,
    resultSpecial: css`
        text-align: center;
        padding-top: 10px;
        p {
            font-size: 18px;
            color: #fff;
            &:first-child {
                span {
                    color: ${colors.yellow};
                    font-weight: 500;
                }
            }
        }
    `,
    specialLotteryHistory: css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 0;

        span {
            width: 36px;
            height: 36px;
            line-height: 34px;
            text-align: center;
            border-radius: 36px;
            background: ${colors.white};
            border: 1px solid ${colors.borderPrimary};
            color: ${colors.blackText};
            font-size: 20px;
            font-weight: 600;
        }
    `,
    nextIssue: css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex: 1;
    `,
    chanelLottery: css`
        font-size: 24px;
        color: ${colors.yellow};
        font-weight: 600;
        border-left: 3px solid ${colors.yellow};
        line-height: 1;
        padding-left: 10px;
    `,
    timerCountLeft: css`
        margin-bottom: 8px;
    `,
    timerCountDown: css`
        display: flex;
        justify-content: center;
    `,
    betSection: css`
			/* background: ${colors.white}; */
		`,
    currentIssue: css`
        margin-bottom: 10px;
        color: ${colors.white};
        span {
            color: ${colors.yellow};
            font-weight: 500;
        }
    `,

    tabTypeBetList: css`
        display: flex;
        background: ${colors.lottery};
        gap: 8px;
        width: 100%;
    `,
    tabTypeItem: css`
        padding: 12px;
        text-align: center;
        color: ${colors.white};
        text-transform: uppercase;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: ${colors.white};
            opacity: 0;
            pointer-events: none;
            z-index: 0;
        }
        &.active {
            span {
                color: ${colors.black};
            }
            &::before {
                opacity: 1;
            }
        }
        span {
            position: relative;
            z-index: 1;
            font-weight: 700;
        }
    `,
    subTabTypeBetList: css`
        display: flex;
        align-items: center;
        gap: 20px;
        margin-top: 20px;
        p {
            margin-left: auto;
            font-size: 14px;
            color: ${colors.lottery};
        }
    `,
    subTabTypeBetItem: css`
        padding: 6px 12px;
        border-radius: 10px;
        border: 1px solid ${colors.lightBlue};
        cursor: pointer;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
        font-size: 18px;
        &.active,
        &:hover {
            background: linear-gradient(to bottom, #1b53f0, #011e98);
            color: ${colors.white};
        }
    `,
    inputBetWrap: css`
        border-radius: 8px;
        border: 1px solid rgba(45, 39, 109, 0.25);
        padding: 12px 10px;
        margin-top: 16px;
    `,
    tabInputBetList: css`
        display: flex;
        gap: 20px;
        margin-bottom: 10px;
    `,
    tabInputBetItem: css`
        padding: 5px 12px 7px;
				border-radius: 10px;
        cursor: pointer;
				border: 1px solid ${colors.lightBlue};
        &.active {
					background: linear-gradient(to bottom, #1b53f0, #011e98);
					cursor: pointer;
					box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
					color: ${colors.white};
        }
    `,

    betTimesInput: css`
        display: flex;
        align-items: center;
        padding: 6px 8px;
        border-radius: 6px;
        border: 1px solid ${colors.lightBlue};
        gap: 5px;
        input {
            border: none;
            outline: none;
            width: 50px;
            text-align: center;
            border: 1px solid ${colors.lightBlue};
        }
        button {
            border: 1px solid ${colors.lightBlue};
            background: #f0f7ff;
            border-radius: 50%;
            width: 22px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:active {
                background: ${colors.primary};
                svg {
                    color: ${colors.white};
                }
            }
            svg {
                color: ${colors.primary};
            }
        }
    `,
    betAction: css`
        padding-top: 12px;
    `,
    betMulti: css`
        display: flex;
        align-items: center;
        gap: 12px;
    `,
    betActionGroup: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        gap: 40px;
    `,
    betNotice: css`
        font-size: 12px;
        span {
            color: ${colors.red};
        }
    `,
    betActionBtn: css`
        display: flex;
        gap: 16px;
        flex: 0 0 40%;
        font-size: 20px;
        button {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 4px;
            text-align: center;
        }
    `,
    betInfo: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #3060ff;
        padding: 10px;
        border-radius: 10px;
        color: ${colors.white};
        span {
            color: #f4ff23;
            font-weight: 500;
        }
    `,
    betInfoLeft: css``,
    betInfoRight: css`
        label {
            font-size: 16px;
            display: inline-block;
            margin-right: 8px;
        }
        select {
            padding: 4px 8px;
            border-radius: 8px;
            background: ${colors.white};
            color: ${colors.black};
            border: 1px solid ${colors.lightBlue};
        }
    `,
    selectRateBet: css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 8px;
    `,

    wrapBet1kAction: css`
        display: flex;
        align-items: center;
        p {
            margin-left: 8px;
        }
    `,
    btnBetAll: css`
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 10px 0;
        width: 70%;
        margin-left: auto;
    `,
    countdownBtn: css`
        border-radius: 4px;
        background: #008cdc;
        padding: 4px 8px;
    `,
    totalMoneyBet: css`
        display: flex;
        align-items: center;
        span {
            font-size: 22px;
            font-weight: 500;
            margin-left: 4px;
            color: ${colors.blue};
        }
    `,
    noResult: css`
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    `,
    lotteryTabIntro: css`
        display: flex;
        align-items: stretch;
        background: #2e276d;
        align-items: center;
        background: linear-gradient(to bottom, #b80005, #710003);
        padding: 0 15px;
    `,
    info: css`
        display: flex;
        -moz-justify-content: flex-start;
        -webkit-box-pack: start;
        justify-content: flex-start;
        -moz-align-items: stretch;
        -webkit-box-align: stretch;
        align-items: stretch;
    `,
};
export default lotteryPageStyles;
